export const UpdateCollaboratorsRepository = Symbol.for('UpdateCollaboratorsRepository');
